/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, string, shape,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import ReactMarkdown from 'react-markdown';

const styles = () => ({
    header: {
        fontSize: '1.3em',
        fontWeight: '300',
        textAlign: 'center',
        display: 'block',
        position: 'relative',
        // TODO: Add decorative border, but at higher level
    },
    background_stroke: {
        display: 'block',
        width: '100%',
        textAlign: 'center',
        '& p': {
            margin: '0 auto',
            padding: '0 .5em',
            textTransform: 'uppercase',
            fontSize: '1.1em',
            fontWeight: 400,
            lineHeight: '2.3em',
            display: 'inline-block',
            background: '#fff',
        },
        '&::after': {
            content: '""',
            position: 'relative',
            borderBottom: 'solid 1px #2f2f2f',
            display: 'block',
            width: '100%',
            top: '-1.37em',
            zIndex: '-1',
        },
    },
});

const Header = ({
    classes, data,
}) => (
    <ReactMarkdown className={`${classes.header} ${data.background_stroke && classes.background_stroke}`} source={data.title} />
);

Header.propTypes = {
    data: shape({
        title: string,
    }).isRequired,
    classes: object.isRequired,
};

export default withStyles(styles)(Header);
